import { render, staticRenderFns } from "./adminDashboard.vue?vue&type=template&id=1e56ed97"
import script from "./adminDashboard.vue?vue&type=script&lang=js"
export * from "./adminDashboard.vue?vue&type=script&lang=js"
import style0 from "./adminDashboard.vue?vue&type=style&index=0&id=1e56ed97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports